define('lib/Podio.UI.Recurrence',['require','underscore','jquery','lib/jquery/jquery.podioDropdown','translate','lib/Podio.Transport.Recurrence','lib/Podio.UI.Tooltips','lib/Podio.UI.SettingsBalloon','lib/Podio.Utils'],function (require) {
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.podioDropdown');
  var t = require('translate');

  var RecurrenceTransport = require('lib/Podio.Transport.Recurrence');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');
  var podioUtils = require('lib/Podio.Utils');

  var defaultOptions = {
    txtDisabled: t('This task needs a due date before you can repeat it. #recurrences')
  };
  var options;

  var PodioRecurrence = function(elmAnchor, valueFieldExpression, givenOptions) {
    var _elmAnchor = elmAnchor;
    var _valueFieldExpression = valueFieldExpression;
    var _elmBalloon, elmSummary, elmRecurrenceText, elmWeekly, elmWeekdays, elmMonthly;
    var elmName, elmSteps, elmRepeatOn, elmWeeklyStep, elmMonthlyStep;
    var elmUntilContainer, elmUntilField, elmAddUntil, elmRemoveUntil;
    var localizedWeekDays;

    options = givenOptions ? _.defaults(givenOptions, defaultOptions) : defaultOptions;
    var currentDateTime = options.currentDateTime;
    var elmRecurrenceEnabled = options.elmRecurrenceEnabled;

    function init() {
      settingsBalloon.signals.onInitialized.add(helpers.setupRecurrenceForm);
      settingsBalloon.signals.onShow.add(handlers.onShow);
      settingsBalloon.signals.onApply.add(handlers.onApply);
      settingsBalloon.signals.onRemove.add(handlers.onRemove);
    }

    function dispose() {
      settingsBalloon.signals.onInitialized.remove(helpers.setupRecurrenceForm);
      settingsBalloon.signals.onShow.remove(handlers.onShow);
      settingsBalloon.signals.onApply.remove(handlers.onApply);
      settingsBalloon.signals.onRemove.remove(handlers.onRemove);

      if(_elmAnchor) {
        settingsBalloon.destroy(_elmAnchor);
      }
    }

    var helpers = {
      setupRecurrenceForm: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          _elmBalloon = elmBalloon;

          elmName = elmBalloon.find('.name');
          elmName.podioDropdown();
          elmName.bind('change.dropdown.podio', handlers.onNameChanged);

          elmWeekly = elmBalloon.find('.weekly');
          elmMonthly = elmBalloon.find('.monthly');

          elmWeekdays = elmBalloon.find('.weekday');
          elmWeekdays.bind('click', handlers.onWeekDayClicked);

          elmSteps = elmBalloon.find('.step');
          elmSteps.podioDropdown();
          elmSteps.bind('change.dropdown.podio', handlers.onStepChanged);
          elmWeeklyStep = elmBalloon.find('.weekly .step');
          elmMonthlyStep = elmBalloon.find('.monthly .step');

          elmRepeatOn = elmBalloon.find('.repeat-on');
          elmRepeatOn.podioDropdown();
          elmRepeatOn.bind('change.dropdown.podio', handlers.onRepeatOnChanged);

          elmAddUntil = elmBalloon.find('.add-until');
          elmAddUntil.bind('click', handlers.onAddUntilClicked);
          elmUntilContainer = elmBalloon.find('.until');
          elmUntilField = elmUntilContainer.find('input[type="text"]');
          elmUntilField.not('.hasDatePicker').datepicker({showOtherMonths: true, selectOtherMonths: true, minDate: currentDateTime});
          elmUntilField.bind('change', handlers.onUntilFieldChanged);
          var elmPickDateButton = elmUntilContainer.find('.pick-date-button');
          elmPickDateButton.bind('click', handlers.onPickDateClick.curry(elmUntilField));
          elmRemoveUntil = elmUntilContainer.find('.remove-until');
          elmRemoveUntil.bind('click', handlers.onRemoveUntilClicked);

          elmSummary = elmBalloon.find('.summary');
          elmRecurrenceText = elmBalloon.find('.highlighted .label .text');

          localizedWeekDays = _.map(elmWeekly.find('input[type="checkbox"]'), function(node) { return $(node).data('dayname'); });

          if(_.isDate(currentDateTime)) {
            helpers.updateTextSummary(currentDateTime);
          } else {
            elmSummary.hide();
          }
        }
      },

      updateTextSummary: function() {
        if(_.isDate(currentDateTime) && elmRecurrenceText) {
          var text = helpers.getRecurrenceText();
          if(text) {
            elmRecurrenceText.text(text);
            elmSummary.show();
          } else {
            elmSummary.hide();
          }
        } else if(elmSummary) {
          elmSummary.hide();
        }
      },

      getRecurrenceText: function() {
        var step;

        if(elmName.val() == 'weekly') {
          var checkedDays = _.map(elmWeekly.find('input[type=checkbox]:checked'), function(node) { return $(node).data('dayname'); });
          var daysText;
          if(checkedDays.length === 0) {
            daysText = '';
          }
          if(checkedDays.length === 1) {
            daysText = checkedDays[0];
          } else {
            var lastDay = checkedDays.pop();
            daysText = checkedDays.join(', ') + ' ' + t('and') + ' ' + lastDay;
          }

          step = elmWeeklyStep.val();
          step = parseInt(step, 10);
          if(step === 1) {
            return t('week on {0} #recurrences').format(daysText);
          } else {
            return t('{0}. week on {1} #recurrences').format(step, daysText);
          }
        } else if (elmName.val() === 'monthly') {
          if(!_.isDate(currentDateTime)) {
            return null;
          }

          step = elmMonthlyStep.val();
          var repeatOn = elmRepeatOn.val();
          if((!step) || (!repeatOn)) {
            return null;
          }

          var repeatText;
          if(currentDateTime.getDate() > 28) {
            repeatText = t('on the last day #recurrences');
          } else if(repeatOn === 'day_of_month') {
            repeatText = t('day {0} #recurrences').format(currentDateTime.getDate());
          } else {
            repeatText = helpers.getWeekOfMonth() + '. ' + helpers.getWeekDayName();
          }

          step = parseInt(step, 10);
          if(step === 1) {
            return t('month on {0} #recurrences').format(repeatText);
          } else {
            return t('{0}. month on {1} #recurrences').format(step, repeatText);
          }
        }
        else if (elmName.val() === 'yearly') {
          return t('year #recurrences');
        }
      },

      getTextSummary: function() {
        var text = helpers.getRecurrenceText();
        if(text) {
          text = t('Every #recurrences') + ' ' + text + ' ';
          if(elmUntilField && elmUntilField.val() !== '') {
            text += t('until #recurrences') + ' ';
            text += elmUntilField.val();
          } else {
            text += t('until forever #recurrences');
          }
          return text;
        } else {
          return null;
        }
      },

      getWeekOfMonth: function() {
        return Math.ceil(currentDateTime.getDate()/7);
      },

      getWeekDayName: function() {
        var mondayBasedWeekIndex = currentDateTime.getDay() - 1;
        if(mondayBasedWeekIndex < 0) {
          mondayBasedWeekIndex = 6;
        }
        return localizedWeekDays[mondayBasedWeekIndex];
      },

      updateAnchorState: function() {
        if(_elmAnchor) {
          _elmAnchor.removeClass('disabled').removeClass('unset').removeClass('set');
          if(_.isDate(currentDateTime)) {
            var nameStr;
            if(_valueFieldExpression) {
              nameStr = $(_valueFieldExpression).val();
            }
            if(nameStr && nameStr !== '' && (!elmRecurrenceEnabled || elmRecurrenceEnabled.val() == 'true')) {
              _elmAnchor.addClass('set');
              if (elmName) {
                _elmAnchor.attr('title', helpers.getTextSummary());
              }
              else {
                _elmAnchor.attr('title', t('Repeat #recurrences'));
              }
            } else {
              _elmAnchor.addClass('unset');
              _elmAnchor.attr('title', t('Repeat #recurrences'));
            }
          } else {
            helpers.disable();
          }

          if(elmRecurrenceEnabled) {
            elmRecurrenceEnabled.val(_elmAnchor.hasClass('set'));
          }
        }
      },

      disable: function() {
        if(_elmAnchor) {
          _elmAnchor.removeClass('disabled').removeClass('unset').removeClass('set');
          _elmAnchor.addClass('disabled');
          _elmAnchor.attr('title', options.txtDisabled);
        }
      },

      reset: function() {
        currentDateTime = null;
        helpers.updateAnchorState();
        if(_elmAnchor && _elmBalloon) {
          settingsBalloon.clear(_elmAnchor, _elmBalloon);
          if(elmName && elmSteps && elmRepeatOn) {
            elmName.trigger("refresh.dropdown.podio");
            elmSteps.trigger("refresh.dropdown.podio");
            elmRepeatOn.trigger("refresh.dropdown.podio");
          }
        }

        if(elmRecurrenceEnabled) {
          elmRecurrenceEnabled.val('false');
        }
      },

      updateWeekMonthVisibility: function() {
        if(elmName && elmWeekly && elmMonthly && elmUntilContainer && elmUntilField) {
          if(elmName.val() === 'monthly') {
            elmWeekly.hide();
            elmMonthly.show();
          } else if (elmName.val() === 'weekly') {
            elmWeekly.show();
            elmMonthly.hide();
          }
          else if (elmName.val() === 'yearly') {
            elmWeekly.hide();
            elmMonthly.hide();
          }
        }

        if(elmUntilField.val() !== '') {
          elmAddUntil.hide();
          elmUntilContainer.show();
        } else {
          elmAddUntil.show();
          elmUntilContainer.hide();
        }
      },

      // Updates texts in parentheses in repeat on select. Also replaces the options with "last day of the month" if day > 28
      updateRepeatOn: function() {
        if(_.isDate(currentDateTime) && elmRepeatOn) {
          options = [];
          if(currentDateTime.getDate() > 28) {
            options.push({ label: t('Last day of the month #recurrences'), value: 'day_of_month' });
          } else {
            options.push({ label: t('Day of the month (day {0}) #recurrences').format(currentDateTime.getDate()), value: 'day_of_month' });
            options.push({ label: t('Day of the week ({0}. {1}) #recurrences').format(helpers.getWeekOfMonth(), helpers.getWeekDayName()), value: 'day_of_week' });
          }
          var selectOptions = _.map(options, function(config) { return '<option value="' + config.value + '">' + config.label + '</option>'; });
          var selectedValue = elmRepeatOn.val();
          elmRepeatOn.html(selectOptions.join(''));
          elmRepeatOn.trigger("destroy.dropdown.podio");
          elmRepeatOn.val(selectedValue);
          elmRepeatOn.podioDropdown();

          if(elmWeekdays) {
            if(elmWeekdays.filter(':checked').length === 0) {
              var mondaynizedDay = currentDateTime.getDay() - 1;
              if(mondaynizedDay < 0) {
                mondaynizedDay = 6;
              }
              $(elmWeekdays[mondaynizedDay]).prop('checked', true);
            }
          }
        }
      }
    };

    var handlers = {
      onShow: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          Tooltips.hideAll();
          if(elmName && elmSteps) {

            if ($(_valueFieldExpression).val()) {
              var defaultValues = JSON.parse($(_valueFieldExpression).val());
              elmName.val(defaultValues['name']);

              if (elmName.val() === 'weekly') {
                elmWeeklyStep.val(defaultValues['step']);
              } else {
                elmMonthlyStep.val(defaultValues['step']);
              }

              elmRepeatOn.val('day_of_week');
              if (defaultValues['config'] && defaultValues['config']['repeat_on']) {
                elmRepeatOn.val(defaultValues['config']['repeat_on']);
              }
              if (defaultValues['config'] && defaultValues['config']['days']) {
                elmWeekdays.each(function(){
                  if (_.include(defaultValues['config']['days'], $(this).data('dayname-value'))) {
                    $(this).prop('checked', true);
                  }
                  else {
                    $(this).prop('checked', false);
                  }
                });
              }
              elmUntilField.val(defaultValues['until']);
            }
            else {
              if(elmName.val() === '') {
                elmName.val('weekly');
              }
              if(elmSteps.val() === '') {
                elmSteps.val('1');
              }
              if(elmRepeatOn.val() === '') {
                elmRepeatOn.val('day_of_week');
              }
            }

            elmName.trigger("refresh.dropdown.podio");
            elmSteps.trigger("refresh.dropdown.podio");
            elmRepeatOn.trigger("refresh.dropdown.podio");

            helpers.updateWeekMonthVisibility();
            helpers.updateRepeatOn();
            helpers.updateTextSummary();
          }
        }
      },

      onApply: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {

          if (elmName.val() !== '') {
            var daysValue = [];
            elmWeekdays.filter(':checked').each(function(){
              daysValue.push($(this).data('dayname-value'));
            });
            var newValue = {
              'name': elmName.val(),
              'config': {
                'days':daysValue,
                'repeat_on':elmRepeatOn.val()
              },
              'step': elmName.val() == 'weekly' ? elmWeeklyStep.val() : elmName.val() === 'yearly' ? 1 : elmMonthlyStep.val(),
              'until':elmUntilField.val()
            };

            $(_valueFieldExpression).val(JSON.stringify(newValue));
            if (elmAnchor.data('ref-id')) {
              RecurrenceTransport.update(elmAnchor.data('ref-type'), elmAnchor.data('ref-id'), newValue);
              elmAnchor.trigger('apply.recurrence.podio');
            }
          }
          else {
            $(_valueFieldExpression).val('');
            if (elmAnchor.data('ref-id')) {
              RecurrenceTransport.destroy(elmAnchor.data('ref-type'), elmAnchor.data('ref-id'));
              elmAnchor.trigger('stop.recurrence.podio');
            }
          }

          if(elmRecurrenceEnabled) {
            elmRecurrenceEnabled.val('true');
          }

          helpers.updateAnchorState();
        }
      },

      onDateTimeChanged: function(newDateTime) {
        currentDateTime = newDateTime;
        helpers.updateAnchorState();

        if(_.isDate(currentDateTime)) {
          helpers.updateTextSummary();
          helpers.updateRepeatOn();
        } else {
          settingsBalloon.hideAll();
          if(_elmAnchor && _elmBalloon) {
            settingsBalloon.clear(_elmAnchor, _elmBalloon);
          }
        }

        if(elmUntilField) {
          elmUntilField.datepicker('option', 'minDate', newDateTime);
        }
      },

      onNameChanged: function() {
        helpers.updateWeekMonthVisibility();
        helpers.updateTextSummary();
        helpers.updateRepeatOn();
      },

      onStepChanged: function() {
        helpers.updateTextSummary();
      },

      onRepeatOnChanged: function() {
        helpers.updateTextSummary();
      },

      onWeekDayClicked: function(e) {
        if(!$(this).is(':checked') && elmWeekdays.filter(':checked').length < 1) {
          return false;
        } else {
          helpers.updateTextSummary();
          return true;
        }
      },

      onRemove: function(elmAnchor, elmBalloon) {
        if(_elmAnchor[0] == elmAnchor[0]) {
          $(_valueFieldExpression).val('');
          if (elmAnchor.data('ref-id')) {
            RecurrenceTransport.destroy(elmAnchor.data('ref-type'), elmAnchor.data('ref-id'));
            elmAnchor.trigger('stop.recurrence.podio');
            elmWeekdays.prop('checked', false);
          }

          if(elmRecurrenceEnabled) {
            elmRecurrenceEnabled.val('false');
          }

          helpers.updateAnchorState();
        }
      },

      onUntilFieldChanged: function(e) {
        helpers.updateTextSummary();
      },

      onAddUntilClicked: function() {
        elmAddUntil.hide();
        elmUntilContainer.show();
        return false;
      },

      onRemoveUntilClicked: function() {
        elmUntilField.val('');
        elmUntilContainer.hide();
        elmAddUntil.show();
        return false;
      },

      onPickDateClick: function(elmDateInput, e) {
        elmDateInput.datepicker('show');
        return false;
      }
    };

    return {
      init: init,
      dispose: dispose,
      dateTimeChanged: handlers.onDateTimeChanged,
      disable: helpers.disable,
      updateAnchorState: helpers.updateAnchorState,
      reset: helpers.reset
    };

  };

  function init(elmAnchor, valueFieldExpression, options) {
    var recurrence = new PodioRecurrence(elmAnchor, valueFieldExpression, options);
        recurrence.init();

    return recurrence;
  }

  return {
    init: init
  };

});


